// Functions for calling the WeTix backend
// these things are extracted into a composable here for re-usablity,
// and so that we can easily change things like the backend URL in the future and/or
// gradually refactor so that we call the database directly.

// useWetixBackend
export default function () {
  const config = useRuntimeConfig()

  return {

    // ## SHOP EVENT PAGE API CALLS ##
    // Get a list of available events for a given tenant.
    getTenantEventsList: async (tenantId: string) => {
      try {
        return useFetch(`${config.public.WETIX_SERVICE_API_BASE_URL}/v1/eventpages/${tenantId}/list-events`)
      } catch (error) {
        console.error(`Error getting available events for tenant ${tenantId}:`, error)
      }
    }

  }
}
